import { IRoute } from "shared/interface/types";
import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";

const parentBreadCrumbs = [
  { title: "menu_sidebar_management" },
  { title: "menu_sidebar_management_list_management" },
  { title: "menu_sidebar_management_list_management_groups" }
];

const HospitalGroupManagementListing = Loadable({
  loader: () => import("container/management/listManagement/groups/hospitalGroups"),
  loading() {
    return <Loader />;
  }
});

const LabGroupManagementListing = Loadable({
  loader: () => import("container/management/listManagement/groups/labGroups"),
  loading() {
    return <Loader />;
  }
});

const CashLessWorkshopGroupManagementListing = Loadable({
  loader: () => import("container/management/listManagement/groups/cashLessWorkshopGroup"),
  loading() {
    return <Loader />;
  }
});

export const groupRoutes: IRoute[] = [
  {
    path: "/management/list_management/groups/hospital",
    element: <HospitalGroupManagementListing />,
    handle: {
      crumbs: [...parentBreadCrumbs, { title: "menu_sidebar_management_list_management_groups_hospital" }]
    }
  },
  {
    path: "/management/list_management/groups/lab",
    element: <LabGroupManagementListing />,
    handle: {
      crumbs: [...parentBreadCrumbs, { title: "menu_sidebar_management_list_management_groups_discount_center" }]
    }
  },
  {
    path: "/management/list_management/groups/cash-less-workshops",
    element: <CashLessWorkshopGroupManagementListing />,
    handle: {
      crumbs: [...parentBreadCrumbs, { title: "menu_sidebar_management_list_management_groups_cash_less_workshop" }]
    }
  }
];
